import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface DealState {
	selectedDealTeamUserId: string | null;
}

const initialState: DealState = {
	selectedDealTeamUserId: null,
};

const dealSlice = createSlice({
	name: 'deal',
	initialState,
	reducers: {
		setSelectedDealTeamUserId: (state, action: PayloadAction<string | null>) => {
			state.selectedDealTeamUserId = action.payload;
		},
	},
});

export const { setSelectedDealTeamUserId } = dealSlice.actions;
export const Deal = dealSlice.reducer;
